<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>Daisies Are Forever</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ct">CONTENTS</p>
<p class="txline"></p>
<p class="cct"><a href="#/chapter3#ctnvii" id="cntvii">GLOSSARY OF FOREIGN WORDS</a></p>
<p class="cct"><a href="#/chapter4#ctn1" id="cnt1">ONE</a></p>
<p class="cct"><a href="#/chapter5#ctn11" id="cnt11">TWO</a></p>
<p class="cct"><a href="#/chapter6#ctn16" id="cnt16">THREE</a></p>
<p class="cct"><span href="#/chapter7#ctn26" id="cnt26" title="Link target outside of Sample">FOUR</span></p>
<p class="cct"><span href="#/chapter8#ctn37" id="cnt37" title="Link target outside of Sample">FIVE</span></p>
<p class="cct"><span href="#/chapter9#ctn44" id="cnt44" title="Link target outside of Sample">SIX</span></p>
<p class="cct"><span href="#/chapter10#ctn53" id="cnt53" title="Link target outside of Sample">SEVEN</span></p>
<p class="cct"><span href="#/chapter11#ctn62" id="cnt62" title="Link target outside of Sample">EIGHT</span></p>
<p class="cct"><span href="#/chapter12#ctn70" id="cnt70" title="Link target outside of Sample">NINE</span></p>
<p class="cct"><span href="#/chapter13#ctn79" id="cnt79" title="Link target outside of Sample">TEN</span></p>
<p class="cct"><span href="#/chapter14#ctn87" id="cnt87" title="Link target outside of Sample">ELEVEN</span></p>
<p class="cct"><span href="#/chapter15#ctn96" id="cnt96" title="Link target outside of Sample">TWELVE</span></p>
<p class="cct"><span href="#/chapter16#ctn106" id="cnt106" title="Link target outside of Sample">THIRTEEN</span></p>
<p class="cct"><span href="#/chapter17#ctn116" id="cnt116" title="Link target outside of Sample">FOURTEEN</span></p>
<p class="cct"><span href="#/chapter18#ctn124" id="cnt124" title="Link target outside of Sample">FIFTEEN</span></p>
<p class="cct"><span href="#/chapter19#ctn133" id="cnt133" title="Link target outside of Sample">SIXTEEN</span></p>
<p class="cct"><span href="#/chapter20#ctn140" id="cnt140" title="Link target outside of Sample">SEVENTEEN</span></p>
<p class="cct"><span href="#/chapter21#ctn148" id="cnt148" title="Link target outside of Sample">EIGHTEEN</span></p>
<p class="cct"><span href="#/chapter22#ctn156" id="cnt156" title="Link target outside of Sample">NINETEEN</span></p>
<p class="cct"><span href="#/chapter23#ctn168" id="cnt168" title="Link target outside of Sample">TWENTY</span></p>
<p class="cct"><span href="#/chapter24#ctn179" id="cnt179" title="Link target outside of Sample">TWENTY-ONE</span></p>
<p class="cct"><span href="#/chapter25#ctn187" id="cnt187" title="Link target outside of Sample">TWENTY-TWO</span></p>
<p class="cct"><span href="#/chapter26#ctn195" id="cnt195" title="Link target outside of Sample">TWENTY-THREE</span></p>
<p class="cct"><span href="#/chapter27#ctn202" id="cnt202" title="Link target outside of Sample">TWENTY-FOUR</span></p>
<p class="cct"><span href="#/chapter28#ctn208" id="cnt208" title="Link target outside of Sample">TWENTY-FIVE</span></p>
<p class="cct"><span href="#/chapter29#ctn215" id="cnt215" title="Link target outside of Sample">TWENTY-SIX</span></p>
<p class="cct"><span href="#/chapter30#ctn227" id="cnt227" title="Link target outside of Sample">TWENTY-SEVEN</span></p>
<p class="cct"><span href="#/chapter31#ctn235" id="cnt235" title="Link target outside of Sample">TWENTY-EIGHT</span></p>
<p class="cct"><span href="#/chapter32#ctn244" id="cnt244" title="Link target outside of Sample">TWENTY-NINE</span></p>
<p class="cct"><span href="#/chapter33#ctn252" id="cnt252" title="Link target outside of Sample">THIRTY</span></p>
<p class="cct"><span href="#/chapter34#ctn261" id="cnt261" title="Link target outside of Sample">THIRTY-ONE</span></p>
<p class="cct"><span href="#/chapter35#ctn270" id="cnt270" title="Link target outside of Sample">THIRTY-TWO</span></p>
<p class="cct"><span href="#/chapter36#ctn282" id="cnt282" title="Link target outside of Sample">THIRTY-THREE</span></p>
<p class="cct"><span href="#/chapter37#ctn291" id="cnt291" title="Link target outside of Sample">THIRTY-FOUR</span></p>
<p class="cct"><span href="#/chapter38#ctn300" id="cnt300" title="Link target outside of Sample">THIRTY-FIVE</span></p>
<p class="cct"><span href="#/chapter39#ctn309" id="cnt309" title="Link target outside of Sample">THIRTY-SIX</span></p>
<p class="cct"><span href="#/chapter40#ctn316" id="cnt316" title="Link target outside of Sample">THIRTY-SEVEN</span></p>
<p class="cct"><span href="#/chapter41#ctn322" id="cnt322" title="Link target outside of Sample">THIRTY-EIGHT</span></p>
<p class="cct"><span href="#/chapter42#ctn330" id="cnt330" title="Link target outside of Sample">EPILOGUE</span></p>
<p class="cct"><span href="#/chapter43#ctn335" id="cnt335" title="Link target outside of Sample">THE STORY BEHIND THE STORY</span></p>
<p class="cct"><span href="#/chapter44#ctn337" id="cnt337" title="Link target outside of Sample">READING GROUP GUIDE</span></p>
<p class="cct"><span href="#/chapter45#ctn339" id="cnt339" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
<p class="cct"><span href="#/chapter46#ctn343" id="cnt343" title="Link target outside of Sample">ABOUT THE AUTHOR</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?64883584